var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 26.2393C5.19385 25.156 0.499405 19.8116 0.499405 13.3838C0.499405 6.23379 6.3494 0.383789 13.4994 0.383789C20.6494 0.383789 26.4994 6.23379 26.4994 13.3838C26.4994 19.8116 21.805 25.156 15.6661 26.2393L14.9438 25.6616H12.055L11.3327 26.2393Z",
    fill: "url(#paint0_linear_15_3022)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.555 16.9949L19.1327 13.3838H15.6661V10.856C15.6661 9.8449 16.0272 9.05045 17.6161 9.05045H19.2772V5.72823C18.3383 5.58379 17.3272 5.43934 16.3883 5.43934C13.4272 5.43934 11.3327 7.2449 11.3327 10.4949V13.3838H8.08274V16.9949H11.3327V26.1671C12.055 26.3116 12.7772 26.3838 13.4994 26.3838C14.2216 26.3838 14.9438 26.3116 15.6661 26.1671V16.9949H18.555Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_3022",
    x1: 13.4994,
    y1: 25.6241,
    x2: 13.4994,
    y2: 0.383789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5d1dae06be91c64dc3ce5b71e1999367.svg";
export { ForwardRef as ReactComponent };